import React from 'react';
import styles from './ProductCard.module.css';
import { ShoppingBagRegular, OpenRegular } from '@fluentui/react-icons';

export interface ProductData {
    name: string;
    url: string;
    price: number;
    currency: string;
    image_url: string;
    button_label?: string;
}

interface ProductCardProps {
    product: ProductData;
}

export const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
    
    let brand = "";
    let title = product.name;

    if (product.name.includes(" - ")) {
        const parts = product.name.split(" - ");
        if (parts.length > 1) {
            brand = parts[parts.length - 1];
            title = parts.slice(0, parts.length - 1).join(" - ");
        }
    }

    return (
        <a href={product.url} target="_blank" rel="noopener noreferrer" className={styles.card}>
            <div className={styles.imageContainer}>
                <img 
                    src={product.image_url} 
                    alt={product.name} 
                    className={styles.image} 
                />
                <div className={styles.priceTag}>
                    <span className={styles.priceText}>
                        {product.price} {product.currency}
                    </span>
                </div>
            </div>

            <div className={styles.content}>
                <div className={styles.header}>
                    <div>
                        {brand && <p className={styles.brand}>{brand}</p>}
                        <h3 className={styles.title}>{title}</h3>
                    </div>
                    <div className={styles.iconContainer}>
                        <OpenRegular className={styles.icon} />
                    </div>
                </div>

                <div className={styles.button}>
                    <ShoppingBagRegular className={styles.buttonIcon} />
                    <span className={styles.buttonText}>
                        {product.button_label || "View Product"}
                    </span>
                </div>
            </div>
        </a>
    );
};

